import { bootstrapApp } from '@/app/bootstrap'

bootstrapApp()
